export default "__VITE_ASSET__c3391a56__"